import { SwapEventCTO } from '@shared/SwapEventCTO'
import { EthAddr } from '@shared/SchemaTypes'
import { logOT } from '@shared/loggingShared'
import axios from 'axios'

export interface SwapEventFetchRequest {
  userAddress?: EthAddr
  tokenContractAddress?: string
  chainId?: number
  serverApiBaseUrl: string
  restAPIKey: string
}

export async function fetchSwapEventsForUser(request: SwapEventFetchRequest): Promise<SwapEventCTO[]> {
  try {
    logOT.info('Fetching swap events for user:', request.userAddress)

    const response = await axios.get(`${request.serverApiBaseUrl}/swapEvents`, {
      headers: {
        'x-api-key': request.restAPIKey,
        'Content-Type': 'application/json',
      },
      params: {
        userAddress: request.userAddress,
        tokenContractAddress: request.tokenContractAddress,
        chainId: request.chainId || 43114,
      },
    })

    if (response.data && Array.isArray(response.data)) {
      return response.data.filter((event: SwapEventCTO) => {
        if (request.userAddress && event.userAddress.toLowerCase() !== request.userAddress.toLowerCase()) {
          return false
        }
        if (
          request.tokenContractAddress &&
          event.tokenContractAddress.toLowerCase() !== request.tokenContractAddress.toLowerCase()
        ) {
          return false
        }
        return true
      })
    }

    return []
  } catch (error) {
    logOT.error('Error fetching swap events:', error)
    return []
  }
}

export async function fetchSwapEventsForTokenPair(
  tokenA: string,
  tokenB: string,
  serverApiBaseUrl: string,
  restAPIKey: string,
  chainId: number = 43114
): Promise<SwapEventCTO[]> {
  try {
    const [eventsA, eventsB] = await Promise.all([
      axios.get(`${serverApiBaseUrl}/swapEvents`, {
        headers: {
          'x-api-key': restAPIKey,
          'Content-Type': 'application/json',
        },
        params: {
          tokenContractAddress: tokenA,
          chainId,
        },
      }),
      axios.get(`${serverApiBaseUrl}/swapEvents`, {
        headers: {
          'x-api-key': restAPIKey,
          'Content-Type': 'application/json',
        },
        params: {
          tokenContractAddress: tokenB,
          chainId,
        },
      }),
    ])

    const allEvents = [...(eventsA.data || []), ...(eventsB.data || [])]

    const uniqueEvents = allEvents.filter((event, index, self) => index === self.findIndex((e) => e.id === event.id))

    return uniqueEvents
  } catch (error) {
    logOT.error('Error fetching swap events for token pair:', error)
    return []
  }
}
